import { useEffect, useRef } from 'react'

import { useI18n } from '@/i18n'

import { useCurrentUser } from './useCurrentUser'

/**
 * 登录后把界面切到**账号里存的**语言。
 *
 * 规则是「账号说了算」：localStorage 那份只负责没登录时可用、以及首屏不闪。
 * 所以在别人的电脑上打开自己的账号，看到的仍然是自己的语言。
 *
 * 代价是：在登录页上临时选了别的语言，登录后会被账号里的设置覆盖回去。
 * 这是刻意的 —— 另一种规则（本地选择反向覆盖账号）会让「昨天在 A 设备选过
 * 日文、今天在 B 设备改成中文」这种情况下，一打开 A 设备就把账号又改回日文。
 */
export function useSyncAccountLanguage(): void {
  const { user } = useCurrentUser()
  const { locale, setLocale } = useI18n()
  // 每个账号只同步一次，否则用户在设置页改完会被这里立刻拽回去
  const syncedFor = useRef<string | null>(null)

  useEffect(() => {
    if (!user?.language) {
      if (!user) syncedFor.current = null
      return
    }
    if (syncedFor.current === user.id) return
    syncedFor.current = user.id
    if (user.language !== locale) void setLocale(user.language)
  }, [user, locale, setLocale])
}
